import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Country, Region, City, DataSourceFilter, DataSourceResponse } from "../../models";
import { AddressApi } from "../base";
import { CountryService, RegionService, CityService } from '../services';

@Injectable()
export class RestAddressApi extends AddressApi {
  constructor(
    public countryService: CountryService,
    public regionService: RegionService,
    public cityService: CityService
  ) {
    super();

  }
  /** City */
  createCity(model: City): Observable<any> {
    return this.cityService.create(model);
  }
  editCity(id: string, model: City): Observable<any> {
    return this.cityService.update(id, model);
  }
  deleteCity(id: string): Observable<any> {
    return this.cityService.delete(id);
  }
  deleteCityRange(ids: string[]): Observable<any> {
    return this.cityService.deleteRange(ids);
  }
  getCities(filter: DataSourceFilter): Observable<DataSourceResponse<City>> {
    return this.cityService.getCities(filter);
  }

  /** Regions */
  deleteRegionRange(ids: string[]): Observable<any> {
    return this.regionService.deleteRange(ids);
  }
  createRegion(model: Region): Observable<any> {
    return this.regionService.create(model);
  }
  editRegion(id: string, model: Region): Observable<any> {
    return this.regionService.update(id, model);
  }
  deleteRegion(id: string): Observable<any> {
    return this.regionService.delete(id);
  }
  getRegions(filter?: DataSourceFilter): Observable<DataSourceResponse<Region>> {
    return this.regionService.getRegions(filter);
  }

  /** Country */
  deleteCountryRange(ids: string[]): Observable<any> {
    return this.countryService.deleteRange(ids);
  }
  createCountry(country: Country): Observable<any> {
    return this.countryService.create(country);
  }

  deleteCountry(countryId: string): Observable<any> {
    return this.countryService.delete(countryId);
  }

  editCountry(id: string, country: Country): Observable<any> {
    return this.countryService.update(id, country);
  }
  getCountries(filter: any) {
    return this.countryService.getCountries(filter);
  }

}
